const list = {
  // =================================================================================================================
  components() {
    return [
      {
        component: "search-start-end",
        label: "작성일",
        value: "date",
        query: { ss: "startDate", ee: "endDate" },
        options: {
          default: { sd: "", ed: "" },
          gridTemplateColumns: "114px auto",
        },
      },
      {
        component: "search-select-field",
        label: "사업장",
        value: "field",
        query: { f_id: "fieldId", f_name: "fieldName" },
        options: { gridTemplateColumns: "114px auto", default: { fieldId: "", fieldName: "" } },
      },
      {
        component: "search-column-keyword",
        label: "검색조건",
        value: "column",
        query: { ck_t: "head", ck_k: "keyword" },
        options: { gridTemplateColumns: "114px auto", hiddenList: ["사업장명", "대상년도", "첨부"] },
      },
    ];
  },
  getConditions: (nav) => {
    const conditions = [];
    const search = nav.value;

    //  검색일
    if (search.date) {
      conditions.push({ key: "created_at", operator: ">=", value: search.date.startDate });
      conditions.push({ key: "created_at", operator: "<", value: search.date.endDate ? new Date(search.date.endDate).addDays(1).format("yyyy-MM-dd") : "" });
    }

    // 사업장
    if (search.field) {
      conditions.push({ key: "body.stdInfo.field_id", operator: "=", value: search.field.fieldId });
    }

    //  검색조건
    const heads = list.getHead().map((e) => {
      return { [e.name]: e.key };
    });
    // 배열의 객체들을 하나의 객체로 합치기
    const types = Object.assign({}, ...heads);
    if (search.column && search.column.keyword) {
      conditions.push({ key: types[search.column.head], operator: "LIKE", value: `%${search.column.keyword}%` });
    }
    return conditions;
  },

  // =================================================================================================================
  getHead: () => {
    return [
      {
        name: "대상년도",
        key: "header.year",
      },
      {
        name: "사업장명",
        key: "body.stdInfo.field_name",
      },
      {
        name: "공장명",
        key: "body.subInfo.공장명",
      },
      {
        name: "Rev",
        key: "body.subInfo.Rev",
      },
      {
        name: "제개정일",
        key: "body.subInfo.제개정일",
      },
      {
        name: "첨부",
        key: "body.fileList",
      },
    ];
  },
  getCol: (index, value, func) => {
    try {
      const postContent = JSON.parse(value.post_content);
      switch (index) {
        case 0:
          return postContent.header.year; // 대상년도
        case 1:
          return func.getContent(value).stdInfo.field_name; // 사업장명
        case 2:
          return func.getContent(value).subInfo.공장명; // 공장명
        case 3:
          const rev = func.getContent(value).subInfo.Rev;
          if (!rev || rev === 0) return "비대상";
          else return rev; // Rev
        case 4:
          return func.getContent(value).subInfo.제개정일; // 제개정일
        case 5:
          // 결과보고서첨부
          const file = func.getContent(value).fileList;
          return {
            type: "file",
            files: file,
          };
      }
    } catch (e) {
      /*ignore*/
    }
    return "";
  },
  getSearchKeyValue: (nav) => {},
  getSearchKeyword: (nav) => {},
};
export default list;
